var common = require('./common')

jQuery(function($) {
  var doFilterType = function(fid)
  {
    $('.panel-purchases').removeClass('hide')
    $('.my-purchases--empty').addClass('hide')

    if ( fid != '' )
    {
      $('.panel-purchases:not(.' + fid + ')').addClass('hide')
    }

    $('.filters-exposed form #type').remove()
    $('<input>').attr({
        type: 'hidden',
        id: 'type',
        name: 'type',
        value: fid
    }).appendTo('.filters-exposed form')

    if( $('.panel-purchases:not(.hide)').length == 0 )
    {
      $('.my-purchases--empty').removeClass('hide')
    }
  }

  doFilterType(common.getURLParameter('type'))

  $('body').on('click', '.filter__account-date li.filters-set__item a, .filter__account-select li.filters-set__item a', function ()
  {
    var jsid  = $(this).data('jsid')
    var field = $(this).data('field')
    var ftype = $(this).data('ftype')
    var fid   = $(this).data('fid')

    $('#dropdown-filter-' + jsid + ' + ul li a').removeClass('active')
    $(this).addClass('active')
    $('#dropdown-filter-' + jsid + ' .text').text($(this).text())

    switch(ftype)
    {
      case 'text':
        $('.filters-exposed [name="' + field + '"]').val(fid)
      break;
      case 'select':
        $('.filters-exposed option[value="' + fid + '"]').prop('selected', true)
      break;
    }

    $('.filters-exposed form').submit()
  })

  $('body').on('click', '.filter__account-type li.filters-set__item a', function ()
  {
    var jsid  = $(this).data('jsid')
    var fid   = $(this).data('fid')

    $('#dropdown-filter-' + jsid + ' + ul li a').removeClass('active')
    $(this).addClass('active')
    $('#dropdown-filter-' + jsid + ' .text').text($(this).text())

    doFilterType(fid)
  })

  // Page user edit
  var fields_user_edit = [
    [ '.is_not_member.is_logged.page--user--edit input[name="field_user__tiers_nom[0][value]"]', '.is_not_member.is_logged.page--user--edit input[name="field_user_adresse_main[0][inline_entity_form][field_adr__tiers_adresse_lastnam][0][value]"]' ],
    [ '.is_not_member.is_logged.page--user--edit input[name="field_user__tiers_prenom[0][value]"]', '.is_not_member.is_logged.page--user--edit input[name="field_user_adresse_main[0][inline_entity_form][field_adr__tiers_adresse_name][0][value]"]' ],
  ]
  var v_aux = ''
  fields_user_edit.forEach(function(element) {
    if ( $(element[0]).length > 0 )
    {
      v_aux = $(element[1]).val()
      if ( v_aux == '' )
      {
        $(element[1]).val($(element[0]).val())
      }
    }
  })

  var civ = $('select[name="field_user__tiers_civilite"]').val()
  if ( $('input[name="field_user_adresse_main[0][inline_entity_form][field_adr__tiers_civility]"]:checked').val() === undefined )
  {
    $('input[name="field_user_adresse_main[0][inline_entity_form][field_adr__tiers_civility]"][value="' + civ + '"]').prop('checked', true)
    $('input[name="field_user_adresse_main[0][inline_entity_form][field_adr__tiers_civility]"][value="' + civ + '"]').attr('checked', 'checked')
  }
})


// WEBPACK FOOTER //
// ./js/my-account.js